"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoTracker = void 0;

var _api = require("../../actions/api");

var _ = require(".");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var SEGMENT_DURATION = 4;
/**
 * VideoTracker is a tracking manager for video
 *
 * @export
 * @class VideoTracker
 */

var VideoTracker = /*#__PURE__*/function () {
  function VideoTracker(clipId, playlistId) {
    var userId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var playlistType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var category = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var action = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
    var label = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
    var playerType = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;

    _classCallCheck(this, VideoTracker);

    this.clipId = clipId;
    this.playlistId = playlistId;
    this.userId = userId;
    this.category = category;
    this.action = action;
    this.label = label;
    this.playlistType = playlistType;
    this.playerType = playerType;
    this.vi = {
      currentTime: null,
      duration: null
    };
    this.lastVideoTime = 0;
    this.durationViewed = 0;
    this.view = null;
    this.saving = false;
    this.lastSegment = SEGMENT_DURATION * -1;
    this.lastQualityEvent = -1;
    this.didReportContent = false;
  }

  _createClass(VideoTracker, [{
    key: "update",
    value: function update(vi) {
      this.vi = vi;
      var ct = vi.currentTime ? vi.currentTime : 0; // Segment Counting

      if (ct > 0) {
        var sid = 0;

        if (ct > 1 && ct < 2) {
          sid = 1;
        } else {
          sid = Math.floor(ct / SEGMENT_DURATION) * SEGMENT_DURATION;
        }

        if (sid > this.lastSegment) {
          this.lastSegment = sid;
          this.videoPlayedSegment(sid);
        }
      } // Quality Views


      if (this.lastVideoTime < ct && ct < this.lastVideoTime + 0.5) {
        this.durationViewed += ct - this.lastVideoTime;
      }

      var qid = Math.floor(this.durationViewed / 2) * 2;
      var twid = Math.floor(this.durationViewed / 4) * 4;

      if (qid > 4 && qid < 8) {
        qid = 4;
      }

      if (qid > 8 && qid < 16) {
        qid = 8;
      }

      if (qid > 16) {
        qid = 16;
      }

      if (qid > this.lastQualityEvent) {
        this.lastQualityEvent = qid;
        this.event("Quality View ".concat(qid), ct);
      }

      if (twid !== this._lastTWID) {
        this._lastTWID = twid;
        this.countTimeWatched();
      }

      this.lastVideoTime = ct;
    }
  }, {
    key: "countTimeWatched",
    value: function () {
      var _countTimeWatched = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var sessionTime, totalTime;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return sessionStorage.getItem("time_watched");

              case 2:
                sessionTime = _context.sent;
                sessionTime = sessionTime ? parseInt(sessionTime, 10) : 0;
                _context.next = 6;
                return localStorage.getItem("time_watched");

              case 6:
                totalTime = _context.sent;
                totalTime = totalTime ? parseInt(totalTime, 10) : 0;

                if (!totalTime) {
                  totalTime = 0;
                }

                totalTime += 4;
                sessionTime += 4;
                sessionStorage.setItem("time_watched", sessionTime);
                localStorage.setItem("time_watched", totalTime);
                document.dispatchEvent(new CustomEvent("trc-time-watched", {
                  detail: {
                    sessionTime: sessionTime,
                    totalTime: totalTime
                  }
                }));

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function countTimeWatched() {
        return _countTimeWatched.apply(this, arguments);
      }

      return countTimeWatched;
    }()
  }, {
    key: "getView",
    value: function () {
      var _getView = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(sid) {
        var url, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!this.view) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", this.view);

              case 2:
                if (!(this.clipId <= 0)) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt("return");

              case 4:
                url = "https://lapi.traceup.com/tracebot-".concat(process.env.REACT_APP_TRACE_ENV, "/tracebot/views");
                data = {
                  viewable_id: this.clipId,
                  viewable_type: "game_clips",
                  user_id: this.userId,
                  group_id: this.playlistId,
                  group_type: this.playlistType,
                  duration: sid
                };

                if (this.category) {
                  data.category = this.category;
                }

                if (this.action) {
                  data.action = this.action;
                }

                if (this.label) {
                  data.label = this.label;
                } else if (this.playerType) {
                  data.label = this.playerType;
                }

                this.saving = true;
                _context2.prev = 10;
                _context2.next = 13;
                return (0, _api.post)(url, data);

              case 13:
                this.view = _context2.sent;

                if (this.view) {
                  this.view.duration = sid;
                }

                _context2.next = 20;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](10);
                console.log("Error saving view", _context2.t0);

              case 20:
                this.saving = false;
                return _context2.abrupt("return", this.view);

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[10, 17]]);
      }));

      function getView(_x) {
        return _getView.apply(this, arguments);
      }

      return getView;
    }()
  }, {
    key: "event",
    value: function () {
      var _event = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(type, video_time) {
        var url, videoElement;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(type === "Segment Played")) {
                  _context3.next = 14;
                  break;
                }

                if (!(this.view && this.view.duration > 1 && this.saving === false)) {
                  _context3.next = 14;
                  break;
                }

                this.saving = true;
                this.view.user_id = this.userId;
                _context3.prev = 4;
                url = "https://lapi.traceup.com/tracebot-".concat(process.env.REACT_APP_TRACE_ENV, "/tracebot/views");
                _context3.next = 8;
                return (0, _api.put)(url, this.view);

              case 8:
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](4);
                console.log("Error saving view", _context3.t0);

              case 13:
                this.saving = false;

              case 14:
                videoElement = document.querySelector("video"); // video "start" and "end" matomo events

                if (["start", "end"].includes(type)) {
                  (0, _.trackEvent)({
                    action: type,
                    label: this.label,
                    element: videoElement
                  });
                } // view location matomo events


                if (type === "start" && this.category && this.action && this.playerType) {
                  (0, _.trackEvent)({
                    context: this.category,
                    action: this.action,
                    label: this.playerType
                  });
                } // quality view matomo events


                if (type.startsWith("Quality View") && this.category && this.action) {
                  (0, _.trackEvent)({
                    context: "".concat(this.category, " > Quality View"),
                    label: this.action,
                    action: type
                  });
                }

                return _context3.abrupt("return", true);

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 10]]);
      }));

      function event(_x2, _x3) {
        return _event.apply(this, arguments);
      }

      return event;
    }()
  }, {
    key: "videoCount",
    value: function () {
      var _videoCount = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(clipId) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.clipId = clipId;

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function videoCount(_x4) {
        return _videoCount.apply(this, arguments);
      }

      return videoCount;
    }()
  }, {
    key: "videoStart",
    value: function videoStart() {
      this.event("start", this.vi.currentTime);
    }
  }, {
    key: "videoPlayedSegment",
    value: function () {
      var _videoPlayedSegment = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(sid) {
        var v;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(sid > 0)) {
                  _context5.next = 5;
                  break;
                }

                _context5.next = 3;
                return this.getView(sid);

              case 3:
                v = _context5.sent;

                if (v) {
                  v.duration = sid;
                  this.event("Segment Played", sid);
                }

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function videoPlayedSegment(_x5) {
        return _videoPlayedSegment.apply(this, arguments);
      }

      return videoPlayedSegment;
    }()
  }, {
    key: "videoEnd",
    value: function videoEnd() {}
  }, {
    key: "videoPlay",
    value: function videoPlay() {}
  }, {
    key: "videoPause",
    value: function videoPause() {}
  }, {
    key: "videoJump",
    value: function videoJump() {}
  }, {
    key: "videoActive",
    value: function videoActive() {}
  }, {
    key: "videoInactive",
    value: function videoInactive() {}
  }], [{
    key: "getViews",
    value: function () {
      var _getViews = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(clipId, playlistId) {
        var url, views;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                url = "https://lapi.traceup.com/tracebot-".concat(process.env.REACT_APP_TRACE_ENV, "/tracebot/views?game_clip_id=").concat(clipId, "&playlist_id=").concat(playlistId);
                _context6.next = 3;
                return (0, _api.get)(url);

              case 3:
                views = _context6.sent;
                return _context6.abrupt("return", views);

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function getViews(_x6, _x7) {
        return _getViews.apply(this, arguments);
      }

      return getViews;
    }()
  }]);

  return VideoTracker;
}();

exports.VideoTracker = VideoTracker;